import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unassignDriverFromVerificationStages } from "../requests/unassign-driver.ts";
import { verifyKeys } from "../queries/keys.ts";
import { UnassignDriverRequest } from "@/features/operations/verifications/verify/types.ts";

// Mutation hook for unassigning a driver from verification stages
export const useUnassignDriverMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data : UnassignDriverRequest) => {
      const response = await unassignDriverFromVerificationStages(data);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [...verifyKeys.all],
      });
    },
  });
};
